import { Injectable, OnDestroy, inject } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslocoService } from "@ngneat/transloco";
import { Subscription } from "rxjs";

const KEY = 'shared.esPaginatorIntl.';

/**
 * MatPaginatorIntl traducido con Transloco. Actualiza los labels cuando se carga
 * o cambia el idioma activo.
 */
@Injectable()
export class CsPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private readonly transloco = inject(TranslocoService);
  private readonly subscription: Subscription;

  constructor() {
    super();
    this.subscription = this.transloco.selectTranslation().subscribe(() => {
      this.itemsPerPageLabel = this.transloco.translate(KEY + 'itemsPerPageLbl');
      this.nextPageLabel = this.transloco.translate(KEY + 'nextPageLbl');
      this.previousPageLabel = this.transloco.translate(KEY + 'previousPageLbl');
      this.lastPageLabel = this.transloco.translate(KEY + 'lastPageLbl');
      this.firstPageLabel = this.transloco.translate(KEY + 'firstPageLbl');
      this.changes.next();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.transloco.translate(KEY + 'rangeLbl', { page: 0, total: length });
    }

    length = Math.max(length, 0);
    const maxPages = Math.ceil(length / pageSize);

    return this.transloco.translate(KEY + 'rangeLbl', { page: page + 1, total: maxPages });
  };

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
